module.exports = __webpack_public_path__ + "static/media/guide-pic.b04d2328.png";